import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DatePicker, BlankDatePicker,  normalizeDate, DefaultButton, WarningButton} from "../../../components";

const Container = styled.div`
  & button {
    margin-right: 1rem;
  }
`;

class DueDateEditor extends React.Component {
  state = {
    editing: false,
    date: ''
  };

  componentDidMount() {
    this.setState({date: this.props.date})
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.date !== nextProps.date) {
      this.setState({date: nextProps.date})
    }
  }

  setDate = (date) => this.setState({date});
  editDate = () => this.setState({editing: true});
  cancelEdit = () => this.setState({editing: false, date: this.props.date});

  saveDate = () => this.props.onSave(this.state.date).then(res =>
    this.setState({
      editing: false,
      date: res.errors ? this.props.date : this.state.date
    })
  );

  render() {
    const {date, editing} = this.state;
    const saveDisabled = !date;
    return (
      <Container className="row">
        <div className="col-sm-3">
          {(date || editing) ? (
            <DatePicker
              value={(date ? normalizeDate(date) : moment.utc().add(1, 'day')).toISOString()}
              onChange={this.setDate}
              disabled={!editing}
            />
          ) : <BlankDatePicker/> }
        </div>
        <div className="col-sm-8">
          {editing ? (
            <React.Fragment>
              <DefaultButton onClick={this.cancelEdit}>Cancel</DefaultButton>
              <WarningButton disabled={saveDisabled} onClick={this.saveDate}>Save</WarningButton>
              
            </React.Fragment>
          ) : (
            <WarningButton onClick={this.editDate}>Edit</WarningButton>
          )}
        </div>
      </Container>
    );
  }
}

DueDateEditor.propTypes = {
  date: PropTypes.string,
  onSave: PropTypes.func.isRequired,
};

export default DueDateEditor;



// WEBPACK FOOTER //
// ./src/modules/sample/components/DueDateEditor.js